import { AdaptiveIcon, ContentIcon, FeedbackIcon, FlexibleIcon, ProgressIcon, TechniqueIcon } from './icons'

// Feature cards data array
export const features = [
  {
    icon: AdaptiveIcon,
    title: 'Adaptive Learning Technology',
    description:
      'Our AI Coach analyzes your typing patterns, identifies strengths and weaknesses, and automatically adjusts lesson difficulty to maximize your learning. No more one-size-fits-all typing exercises - every practice session is precisely calibrated to your current skill level.',
  },
  {
    icon: FeedbackIcon,
    title: 'Personalized Feedback',
    description:
      'Receive detailed, actionable feedback on your typing performance. The AI Coach identifies specific areas for improvement such as finger positioning, rhythm consistency, and common error patterns, then provides targeted suggestions to help you overcome these challenges.',
  },
  {
    icon: ContentIcon,
    title: 'Engaging, Custom Content',
    description:
      'Say goodbye to boring, repetitive typing drills. Our AI generates fresh, interesting content based on your interests and learning goals, making each practice session more engaging and relevant to your needs.',
  },
  {
    icon: ProgressIcon,
    title: 'Comprehensive Progress Tracking',
    description:
      'Monitor your improvement with detailed analytics that track speed, accuracy, problem keys, and overall progress over time. Set personal goals and watch as the AI Coach helps you achieve them through structured, personalized learning paths.',
  },
  {
    icon: TechniqueIcon,
    title: 'Advanced Typing Techniques',
    description:
      'Move beyond basic typing skills with advanced lessons on specialized keyboard shortcuts, coding syntax practice, and industry-specific terminology relevant to your field or interests.',
  },
  {
    icon: FlexibleIcon,
    title: 'Flexible Practice Sessions',
    description:
      'Whether you have 5 minutes or an hour, the AI Coach optimizes your practice time with sessions designed to fit your schedule while maximizing skill development and retention.',
  },
]
